import type { Menu } from '#/global'

const menus: Menu.recordRaw = {
  path: '/app-version',
  meta: {
    title: 'APP版本管理',
    icon: 'i-ep:mobile-phone',
  },
}

export default menus
